import { render } from "./kubernetes.svg?vue&type=template&id=a6f23a7c?inline"
const script = {}

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__